import { makeAutoObservable, runInAction } from "mobx";
import Api from "../Components/Api";
import { BASE_API_URL } from "../Components/const";

class BlockStore {
  responseBlockList = null;
  responseMoviesInBlock = null;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  // ==================== БЛОКИ ====================

  // Получить список всех блоков
  async getBlockList() {
    this.loading = true;
    try {
      const response = await Api.get(`${BASE_API_URL}/api/blocklist/list`);

      runInAction(() => {
        this.responseBlockList = response.data;
      });
    } catch (error) {
      console.error("Ошибка при получении списка блоков:", error);
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  // Создать новый блок
  async addBlock(name, bundle_id = 0) {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/blocklist/add`, {
        name,
        bundle_id,
      });

      // После создания сразу обновляем список блоков
      await this.getBlockList();
      return response.data;
    } catch (error) {
      console.error("Ошибка при создании блока:", error);
      throw error;
    }
  }

  // Удалить блок
  async deleteBlock(block_id) {
    try {
      await Api.post(`${BASE_API_URL}/api/blocklist/delete`, { block_id });

      // После удаления обновляем список
      await this.getBlockList();
    } catch (error) {
      console.error("Ошибка при удалении блока:", error);
      throw error;
    }
  }

  // ==================== ФИЛЬМЫ В БЛОКЕ (BUNDLE) ====================

  // Добавить фильм в блок
  async addMovieToBlock(movie_id, block_id) {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/block/add`, {
        movie_id,
        block_id,
      });
      await this.getBlockList(); // обновляем весь список блоков
      return response.data;
    } catch (error) {
      console.error("Ошибка при добавлении фильма в блок:", error);
      throw error;
    }
  }

  // Удалить фильм из блока
  async removeMovieFromBlock(id, block_id) {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/block/remove`, {
        id,
        block_id,
      });
      await this.getBlockList();
      return response.data;
    } catch (error) {
      console.error("Ошибка при удалении фильма из блока:", error);
      throw error;
    }
  }

  // Поднять фильм вверх в блоке
  // async moveMovieUp(movie_id, block_id) {
  //   try {
  //     const response = await Api.post(`${BASE_API_URL}/api/block/up`, {
  //       movie_id,
  //       block_id,
  //     });
  //     await this.getBlockList();
  //     return response.data;
  //   } catch (error) {
  //     console.error("Ошибка при поднятии фильма вверх:", error);
  //     throw error;
  //   }
  // }

  // Опустить фильм вниз в блоке
  async moveMovieDown(id, block_id) {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/block/down`, {
        id,
        block_id,
      });
      await this.getBlockList();
      return response.data;
    } catch (error) {
      console.error("Ошибка при опускании фильма вниз:", error);
      throw error;
    }
  }

  // Изменить группу (bundle) у блока
  async editBlockBundle(block_id, bundle_id) {
    try {
      const response = await Api.post(`${BASE_API_URL}/api/blocklist/edit`, {
        block_id,
        bundle_id,
      });
      await this.getBlockList(); // обновляем список блоков
      return response.data;
    } catch (error) {
      console.error("Ошибка при изменении группы блока:", error);
      throw error;
    }
  }

  // Получить список фильмов в конкретном блоке
  async getMoviesInBlock(block_id) {
    this.loading = true;
    try {
      const response = await Api.get(`${BASE_API_URL}/api/block/list`, {
        params: { block_id },
      });

      runInAction(() => {
        this.responseMoviesInBlock = response.data; // сохраняем ответ
      });
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении фильмов в блоке:", error);
      throw error;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

// Создаём и экспортируем единственный экземпляр
const blockStore = new BlockStore();
export default blockStore;
